import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { CATEGORIES } from "@/mocks/site";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div ref={ref} className="relative w-full">
      <label className="mb-2 block text-sm font-medium text-foreground-700">{t("dropdown.label")}</label>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-left text-sm text-foreground-800 transition-colors hover:border-primary-300"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="flex items-center gap-2">
          <i className="ri-price-tag-3-line text-base text-foreground-500" />
          {t("dropdown.placeholder")}
        </span>
        <i className={`ri-arrow-down-s-line text-base transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <ul
          className="absolute left-0 right-0 z-30 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50 py-1 text-sm"
          role="listbox"
        >
          {CATEGORIES.map((cat) => (
            <li key={cat.key}>
              <a
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setOpen(false)}
                className="flex items-center justify-between px-4 py-2.5 text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
                role="option"
              >
                <span className="whitespace-nowrap">{t(`category.${cat.key}`)}</span>
                <i className="ri-arrow-right-up-line text-foreground-400" />
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}